import { useEffect } from 'react';
import { DocumentKey, DocumentPath } from './DocumentationButton/types';
import { useDocumentationLinkContext } from './DocumentationLinkProvider';

type UseDynamicDocumentationLinkOptions = { link: DocumentKey };
/**
 * Some Pages need to set the documentation link dynamically
 *
 * (such as in-page routing, tabs, etc)
 *
 * When the component unmounts, the dynamic documentation link will automatically reset to null
 *
 */
export const useDynamicDocumentationLink = ({ link }: UseDynamicDocumentationLinkOptions) => {
  const context = useDocumentationLinkContext();
  const { setLink, clearLink, setKey } = context
    ? context
    : { setLink: () => {}, clearLink: () => {}, setKey: () => {} };
  useEffect(() => {
    if (link) {
      setLink(DocumentPath[link]);
      setKey(link);
    }
    return () => {
      clearLink();
      setKey(null);
    };
  }, [clearLink, link, setKey, setLink]);
};
